import { module } from 'modujs';
import { html } from '../utils/environment';
import { gsap } from 'gsap';

const CLASS = {
    IS_LOADING: 'is-loading',
    IS_HIDDEN: 'is-hidden'
}

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.$projects = this.$('project');
        
        this.$baseProjects = new Array(this.$projects.length);
        this.$projects.forEach(($project) => {
            this.$baseProjects.push($project);
        });

        // this.$filteredProjects = new Array();

    }

    filtering(filter) {
        if(this.delay != undefined) {
            this.delay.kill();
        }

        this.el.classList.add(CLASS.IS_LOADING);

        this.$filteredProjects = [];
        
        console.log(filter);
        
        this.delay = gsap.delayedCall(0.6,() => {
            this.el.innerHTML = '';
            this.$baseProjects.forEach(($project) => {

                let categories = $project.getAttribute('data-categories').split(',');
                let isHidden = true;

                categories.forEach((category) => {
                    if(filter == category) {
                        isHidden = false;
                    }
                });

                if(!isHidden || filter == 'all') {
                    this.el.append($project);
                }
            });
            

            gsap.delayedCall(0.2,() => {
                this.call('refresh','Scroll');
                this.display();
            });
        });
    }

    display() {
        this.el.classList.remove(CLASS.IS_LOADING);
    }
}
